<template>
    <div class="container">
        <div
                v-for="(item2, index2) in hxContentList"
                :key="index2"
                class="video"
        >
            <div v-if="item2.title" class="title" style="margin-bottom: 10px">
                {{ item2.title }}
            </div>
            <div
                    v-if="item2.subtitle"
                    style="margin-bottom: 10px; color: #333; font-size: 12px"
            >
                {{ item2.subtitle }}
            </div>
            <Video v-if="isVideo=='手机'"
                   zoom="cover"
                   :poster="item2.url"
                   :width="videoWidth"
                   :height="videoHeight"
                   :playWidth="playWidth"
                   :src="item2.file"
            ></Video>
            <!--            无封面-->
            <Video
                    v-else-if="isVideo=='pc'"
                    zoom="cover"
                    :width="videoWidth"
                    :height="videoHeight"
                    :playWidth="playWidth"
                    :src="item2.file"
            ></Video>
        </div>
    </div>
</template>

<script>
    import Video from "../video/index";

    export default {
        name: "video-index",
        props: {
            hxContentList: Array,
        },
        components: {
            Video,
        },
        data() {
            return {
                screenWidth: 0,
                videoWidth: '100%',
                videoHeight: '100%',
                playWidth: '100%',
                isVideo: true,
            }
        },
        mounted() {
            // 获取当前的宽度
            this.screenWidth = document.body.clientWidth;
            window.onresize = () => {
                return (() => {
                    this.screenWidth = document.body.clientWidth;
                })();
            };
        },
        watch: {
            // 监视当前宽度变化
            screenWidth: {
                handler: function (val) {
                    if (!val) {
                        return;
                    }
                    if (val <= 570) {
                        this.videoWidth = '100%';
                        this.videoHeight = '100%';
                        this.playWidth = '20%';
                        this.isVideo = '手机'
                        console.log(this.isVideo)
                    } else if (val >= 570 && val <= 870) {
                        this.videoWidth = '100%';
                        this.videoHeight = '100%';
                        this.playWidth = '20%';
                        this.isVideo = 'pc'
                    } else {
                        this.videoWidth = '90%';
                        this.videoHeight = '90%';
                        this.playWidth = '20%';
                        this.isVideo = 'pc'
                    }
                },
            },
        },
    }
</script>

<style scoped>

    .container {
        width: 70%;
    }

    .video {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        /*padding: 0 25px;*/
    }

    .title {
        font-size: 26px;
        font-weight: bold;
        margin-top: 10px;
    }

    @media screen and (min-width: 1400px) {

        .container {
            width: 70%;
        }
    }

    @media screen and (max-width: 1200px) {
        .container {
            width: 70%;
        }
    }
    @media screen and (max-width: 870px) {
        .container {
            width: 90%;
        }
    }
    @media screen and (max-width: 570px) {
        .container {
            width: 90%;
        }
    }
</style>

